
import api from './api'
import { useDownload } from '@/helpers/download'

export default {
    
    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/tags/destockage/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },

    count(params = {}) {

        return api.get('/tags/destockage', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    list(params = {}) {

        return api.get('/tags/destockage', { params })
            .then( json => json.data )
            
    },

    search(params = {}) {

        return api.get('/tags/destockage', { params })
            .then( json => json.data )            
    } 
}
